import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit
} from '@angular/core';
import {Item} from "../../models/Item";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {MeasurementService} from "../../services/measurementAdapter/measurement.service";
import {isViewMode, isViewModeByShareLink} from 'src/configs/view_only';
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {CookieService} from "../../services/coockieService/coockie.service";
import {ObjectConfig} from "../../models/ObjectConfig";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {ReplaySubject, Subject, Subscription} from "rxjs";
import {debounceTime, takeUntil} from "rxjs/operators";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {ObjectArrayPlugin} from '@src/app/classes/plugins/objectArrayPlugin/object-array-plugin';
import {ActionLogService} from "@src/app/services/actionLogService/action-log.service";


declare var jQuery;
declare var Yiit;

@Component({
  selector: 'app-object-properties',
  templateUrl: './object-options.component.html',
  styleUrls: ['./object-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ObjectOptionsComponent extends AbstractObserver implements OnInit, OnDestroy, OnChanges {
  @Input() itemElm:Item;


  public Yiit = Yiit;
  public hasMeasurement;
  public isOptionsVisible = false;
  public isViewMode = isViewMode || isViewModeByShareLink;
  public _isVisible = true;
  private destroy$ = new Subject();
  private subscription$:Subscription;

  constructor(protected itemManagerService:ItemManagerService,
              protected measurementAdapter: MeasurementService,
              protected cd: ChangeDetectorRef,
              protected concreteService: ConcreteLayerService,
              protected modalControl: EsBsModalService,
              protected cookieService: CookieService,
              protected ui: UiAdapterService,
              protected actionLogService: ActionLogService
              ) {
    super();
  }

  ngOnInit() {
    this.hasMeasurement = this.measurementAdapter.hasMeasurement(this.itemElm);

    this.subscribeToObservable(this.itemElm.config.subject.pipe(takeUntil(this.destroy$)),()=>{
      if (!this.cd['destroyed']) {
        this.cd.detectChanges();
      }
    });
    this.subscribeToObservable(this.itemElm.config.serverUpdate.pipe(takeUntil(this.destroy$)),()=>{
      if (!this.cd['destroyed']) {
        this.cd.detectChanges();
      }
    });

    this.subscribeToObservable(this.itemElm.getSubject(Item.SUBJECT_VISIBILITY).pipe(takeUntil(this.destroy$)),(v) => {
      this._isVisible = v;
    });
    this.DOMListeners();
  }

  ngOnChanges(changes): void {
    if (this.subscription$){
      this.subscription$.unsubscribe();
    }
    this.subscription$ = new Subscription();
    this.subscription$.add(this.itemElm.getObservable('RELOAD_COMPONENT').pipe(debounceTime(500)).pipe(takeUntil(this.destroy$)).subscribe(()=>{
      if (!this.cd['destroyed']){
        this.cd.detectChanges();
      }
    }));
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.cd.detach();
  }

  private DOMListeners(){
    let self = this;
    if (jQuery){
      jQuery(document).on('mouseout', '.ng-tooltip', function (e) {
        if (e && e.relatedTarget){
          if (jQuery('.es-options-hidden-container').has(e.relatedTarget).length == 0){
            self.setOptionsVisible(false);
          }
        }
      })
    }
  }

  getNextMeasurementSystem(){
    return this.measurementAdapter.getNextMeasurementSystemName(this.itemElm);
  }

  changeMeasurement(){
    this.measurementAdapter.changeMeasurement(this.itemElm);
  }

  toggleOptionsVisible(){
    //todo: when click at document close all windows except current
    this.isOptionsVisible = !this.isOptionsVisible;
  }

  checkForClosePopup(e, item?:Item){
    let classList: DOMTokenList =  (e.relatedTarget) ? e.relatedTarget.classList : null;
    if (!classList || !classList.contains('ng-tooltip')){
      this.setOptionsVisible(false);
    }
  }

  private setOptionsVisible(val:boolean){
    this.isOptionsVisible = val;
    this.cd.markForCheck();
  }

  isStaticInputAddAvailable(name){
    return !this.itemElm.config.getInputs().hasOwnProperty(name);
  }

  // isObjectsArrayEmpty(){
  //   return this.itemElm.config.getInputProp('objectArray', 'value');
  // }
  //
  // addObjectArray(){
  //   this.itemElm.config.setInputValue('objectArray', 'value', true)
  // }

  //todo: Move to components staticParamsPlugin
  addStaticField(method){
     this.itemElm.getSubject(Item.SUBJECT_INPUTS_CHANGED).next(method);
  }

  removeItem(removeWithoutConfirm?){
    if (this.isPresetActiveItem()){
      return;
    }

    let confirmMessage = ObjectArrayPlugin.isItemHasObjectArray(this.itemElm) || this.itemElm.config.isCopy? Yiit.t('Are you sure? The whole array will be deleted.') : Yiit.t('Are you sure?');
    let isDel = confirm(confirmMessage);
    if (!isDel) return;
    let itemToRemove = this.itemElm.config.isCopy ? this.itemManagerService.getItemById(this.itemElm.config.getCopyParentId) : this.itemElm;
    itemToRemove.removeObject();
    this.isOptionsVisible = false;
  }

  duplicateItem() {
    if (this.isPresetActiveItem()){
      return;
    }
    const actionId = this.actionLogService.getNextActionId();
    let copies = this.itemManagerService.getAllItemCopies(this.itemElm);
    this.itemManagerService.duplicateItem(this.itemElm, null, {}, null, actionId).then((newItem:Item)=>{
      if (copies.length > 0){
        copies.forEach((copy:Item, index)=>{
          let optionsToOverride = {copyOf: newItem.getId()};
          this.itemManagerService.duplicateItem(copy, null, optionsToOverride, null, actionId).then(()=>{
            if (index == copies.length -1){
              this.ui.selectedItem$ = newItem;
            }
          });
        })
      }
    });
  }

  isPresetActiveItem(){
    return this.itemElm.config.getInputProp(Item.SET_UP_AREA_INPUT,'active');
  }

  isVisible() {
    return this._isVisible;
  }

  hideItem() {
    this.itemElm.setVisibility(false);
  }

  showItem() {
    this.itemElm.setVisibility(true);
  }

  isRotationAvailable() {
    return ([ObjectConfig.TYPE_FIXED_FIGURE].indexOf(this.itemElm.config.getObjectConfig().getToolType()) >= 0);
  }

}
